// @flow

type Options = {
  text: string,
  // advancedData.memedConnected: missing on an API without it
  connected: ?boolean,
  memedUrl: string,
  patientId: number,
};

// A doctor who hasn't connected Memed goes to Ajustes › Memed, and back to this chart. An API
// without memedConnected keeps opening Memed, whose page then explains how to connect
export const memedPrescriptionItem = ({
  text, connected, memedUrl, patientId,
}: Options): Object => (connected === false
  ? { text, linkTo: `/ajustes/modelos/memed?voltar=${encodeURIComponent(`/paciente/${patientId}/prontuario`)}` }
  : { text, externalLinkTo: memedUrl });
